import { ApiResponse } from "@/interfaces/api-response";
import { CropSettings } from "@/interfaces/crop-settings";
import apiClient from "@/utils/axios";

const SERVICE_ENDPOINT = "crop-settings";

const getMany = async (params: {
  sort?: string;
  page?: number;
  size?: number;
  search?: string;
}) => {
  const response = await apiClient.get<ApiResponse<CropSettings[]>>(
    `/${SERVICE_ENDPOINT}`,
    { params },
  );
  return response.data;
};

const cropSettingsApi = {
  getMany,
};

export default cropSettingsApi;
